import React from 'react';
import {
    Segment,
    Button,
    Divider,
    Icon,
    Table,
    Checkbox,
    Header,
    Form,
    Input,
    Grid,
    Message,
    Loader
} from 'semantic-ui-react';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { toast, ToastContainer } from 'react-toastify';


axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


export default class ConnectStudentWithCandidate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            studentLoader: true,
            date: new Date(),
            student: '',
            studentOptions: [],
            semesters: []
        };
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.validateInput = this.validateInput.bind(this);
        this.getStudyProgramSemesters = this.getStudyProgramSemesters.bind(this);
    }

    handleDateChange(name, date) {
        this.setState({
            [name]: date
        });
    }

    componentDidMount() {
        this.getStudyProgramSemesters();
        let candidateId = localStorage.getItem('candidateId');
        axios.get(`/equivalence/${candidateId}/student-study-programs`).then(response => {
            this.setState({
                studentLoader: false,
                studentOptions: response.data.map(el => ({
                    value: { id: el.studentStudyProgramId, text: el.studentFirstName + ' ' + el.studentLastName + ' | ' + el.index + ' | ' + el.jmbg },
                    key: el.studentStudyProgramId,
                    text: el.studentFirstName + ' ' + el.studentLastName + ' | ' + el.index + ' | ' + el.jmbg
                }))
            });
        }).catch(() => {
            this.setState({ studentLoader: false });
            toast('Greška pri dobavljanju svih studenata!');
        });
    }

    getStudyProgramSemesters() {
        let semester = localStorage.getItem('targetStudyProgramId');
        axios.get(`/study-programs/study-program-semesters/${semester}`)
            .then(res => {
                this.setState({
                    semesters: res.data.map(el => ({
                        key: el.id, value: el.id, text: el.name
                    })),
                    loader: false,
                });
            });
    }

    handleInputChange(e, { name, value }) {
        this.setState({ [name]: value });
    }

    validateInput() {
        if (!this.state.student || !this.state.studyProgramSemesters) {
            toast(<FormattedMessage id="common.requiredFields" />);
            if (!this.state.student) { this.setState({ studentErr: true }); } else { this.setState({ studentErr: false }); }
            if (!this.state.studyProgramSemesters) { this.setState({ studyProgramSemestersErr: true }); } else { this.setState({ studyProgramSemestersErr: false }); }
        } else {
            this.setState({ disableCreateButton: true });
            this.props.connectCandidateWithStudent(this.state.student.id, this.state.studyProgramSemesters);
        }
    }

    render() {
        let candidateDisplayName = localStorage.getItem('candidateFirstName') + ' ' + localStorage.getItem('candidateLastName');

        return (


            <div>
                <Segment clearing secondary>
                    <Segment >
                        <Grid columns={2}>
                            <Divider vertical>

                                <Icon name="exchange" />

                            </Divider>

                            <Grid.Column>

                                <Form>

                                    <Form.Group widths="equal">

                                        <Form.Field >
                                            <label>
                                                Kandidat
                                            </label>
                                            <input
                                                required
                                                fluid
                                                disabled
                                                placeholder="Kandidat"
                                                control={Input}
                                                value={candidateDisplayName}
                                            />
                                        </Form.Field>

                                    </Form.Group>


                                </Form>

                            </Grid.Column>

                            <Grid.Column>

                                <Form>


                                    <Form.Group widths="equal">
                                        { this.props.isConnected && <Form.Field >
                                            <label>
                                                Student
                                            </label>
                                            <input
                                                fluid
                                                disabled
                                                placeholder="Student"
                                                control={Input}
                                                value={this.state.student.text}
                                            />
                                        </Form.Field>}
                                        {!this.props.isConnected && <Form.Field required error={this.state.studentErr}>
                                            <label>
                                                Student
                                            </label>
                                            <Form.Dropdown
                                                loading={this.state.studentLoader}
                                                clearable
                                                placeholder="Odaberite studenta"
                                                value={this.state.student}
                                                onChange={this.handleInputChange}
                                                name="student"
                                                options={this.state.studentOptions}
                                                search
                                                fluid
                                                focus
                                                disabled={this.props.isConnected}
                                                selection

                                            />
                                        </Form.Field>}
                                    </Form.Group>


                                </Form>

                            </Grid.Column>

                        </Grid>
                    </Segment>


                    <Loader active={this.state.disableCreateButton} />
                    <Segment clearing>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field required>
                                    <label>
                                        Semestar od kojeg student počinje studij na trenutnom nastavnom planu i programu
                                    </label>
                                    <Form.Dropdown
                                        error={this.state.studyProgramSemestersErr}
                                        placeholder="Odaberite semestar"
                                        search
                                        fluid
                                        selection
                                        options={this.state.semesters}
                                        onChange={this.handleInputChange}
                                        value={this.state.studyProgramSemesters}
                                        name="studyProgramSemesters"
                                        clearable

                                    />
                                </Form.Field>

                            </Form.Group>
                        </Form>
                    </Segment>
                    <Button basic color="blue" floated="right" disabled={this.state.disableCreateButton} onClick={this.props.closeForm} >Odustani</Button>
                    <Button primary color="blue" disabled={this.state.disableCreateButton} floated="right" onClick={this.validateInput} >Poveži</Button>
                </Segment>

                {/* <ToastContainer hideProgressBar /> */}

            </div>);
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/ExamEquivalence/Candidates/CandidatesDetails/Status/ConnectStudentWithCandidate.js